var THREE         = require("three");
var LocalRotationHandleView  = require("./../abstract/localRotationHandleView.js");
var lib_core      = require("lib-core");
 
var LocalXRotationView = function (model, editorView, handleId, config) {
    LocalRotationHandleView.call(this, model, editorView, handleId, config);
}

lib_core.inherit(LocalXRotationView, LocalRotationHandleView);

LocalXRotationView.prototype.repositionMesh = function(mesh, position){
    var matrix = (new THREE.Matrix4()).setPosition( position.toThreejs() );
    mesh.matrix = matrix;
}

LocalXRotationView.prototype.buildMesh = function(radius){
    var obj = new THREE.Object3D();
    obj.matrixAutoUpdate = false;
    var geom = this.buildGeometry(radius).rotateY(Math.PI/2);
    var mesh = new THREE.Mesh(geom, this.material);
    obj.add(mesh);
    return obj
}



module.exports = LocalXRotationView;

